import { BusinessAccountTypeSelection } from '@components/RouteComponents/BusinessAccountTypeSelection'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_initialized/businessAccountTypeSelection'
)({
  component: BusinessAccountTypeSelection,
})
